import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestPluginUpdatePatch = {
    path: "/plugin-update/:slug",
    method: RouteHttpVerb.PATCH
};
